import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/dark-action-theme.css';

// Remove the initial loader once React is ready
const root = document.getElementById('root')!;
const loader = root.querySelector('.initial-loader');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Remove loader after React has mounted
if (loader) {
  requestAnimationFrame(() => {
    loader.remove();
  });
}

// Initialize service worker for offline support (only in production)
// Deferred to not block initial load
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // Further defer service worker registration
    setTimeout(() => {
      navigator.serviceWorker
        .register('/sw.js')
        .then(registration => {
          console.log('SW registered: ', registration);
        })
        .catch(registrationError => {
          console.log('SW registration failed: ', registrationError);
        });
    }, 2000);
  });
}
